import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Tag,
    Select,
    Box
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import DoencaService from "../../../main/services/DoencaService";
import { useHistory } from 'react-router-dom';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { doencaFunc } from '../../../helpers/Funcionalidades'
import { Group } from '../Criancas/Group';


const EditarDoenca = (props) => {

    let history = useHistory();

    document.title = 'MCA - Doenças - Editar'

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    const [doenca, setDoenca] = useState([])
    //const [isUpdating, setIsUpdating] = useState(props.match.params.editar ? true : false)
    const [descricaoCount, setDescricaoCount] = useState(0);

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    function fetchData() {
        DoencaService.getDoenca(props.match.params.id)
            .then(res => {
                setDoenca(res.data);
                setDescricaoCount(res.data.descricao.length);

                if (res.data.dataFim !== null) {
                    Swal.fire({
                        title: 'Erro!',
                        'text': "Você não pode alterar um registro inativo!",
                        icon: 'error',
                        confirmButtonText: 'Fechar',
                        confirmButtonColor: '#169499'
                    }).then(() => {
                        history.push("/doenca/lista")
                    })
                }

            }).catch((err) => {
                Swal.fire({
                    title: 'Atenção!',
                    'text': "Registro não encontrado",
                    icon: 'warning',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(() => {
                    history.push("/doenca/lista");
                })
            })
    }

    const validate = (values) => {
        const errors = {};

        if (!values.descricao || values.descricao === "") {
            errors.descricao = "Descrição é obrigatória!";
        }

        if (!values.dispensaLaudo || values.dispensaLaudo === "") {
            errors.dispensaLaudo = "Dispensa laudo é obrigatório!";
        }

        return errors;
    };

    return roleKeycloack && roleKeycloack.includes(doencaFunc.doencaEditar) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize={'large'}>
                    Editar Doença
                </Heading>
                <Button onClick={history.goBack} colorScheme={"teal"} px={16}>
                    Voltar
                </Button>
            </Flex>
            <Flex>

                <Formik
                    enableReinitialize
                    validate={validate}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        descricao: doenca.descricao || "",
                        dispensaLaudo: doenca.dispensaLaudo || "",
                    }}

                    onSubmit={(values, actions) => {
                        DoencaService.atualizarDoenca(doenca.id, values)
                            .then((res) => {
                                Swal.fire({
                                    title: 'Sucesso!',
                                    'text': 'Registro atualizado com sucesso!',
                                    icon: 'success',
                                    confirmButtonText: 'Continuar',
                                    confirmButtonColor: '#169499'
                                }).then(function () {
                                    actions.setSubmitting(false);
                                    history.push("/doenca/" + res.data.id)
                                });

                                actions.setSubmitting(false);
                                //setIsUpdating(false)
                            }).catch((error) => {
                                actions.setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                                actions.setSubmitting(false);
                            })
                    }}>
                    {(props) => (
                        <Flex
                            flexDir="column"
                            mt="40px"
                            w="100%">
                            <Form>
                                <Flex flexDir="column">
                                    <Group bgColor="#fff" title="" py="12px" >
                                        <Box width={{ lg: '50%' }}>
                                            <Field name="descricao">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column">
                                                        <FormControl isInvalid={form.errors.descricao && form.touched.descricao}>
                                                            <FormLabel htmlFor="descricao">Descrição*</FormLabel>
                                                            <Input
                                                                h="42px"
                                                                autoFocus
                                                                backgroundColor={"white"}
                                                                id="descricao"
                                                                {...field}
                                                                placeholder="Informe a Descrição da Doença"
                                                                maxLength={255}
                                                                onChange={(e) => {
                                                                    setDescricaoCount(e.target.value.length);
                                                                    form.setFieldValue(field.name, e.target.value);
                                                                }}
                                                            />
                                                            <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                            <Flex flexDirection="row-reverse">
                                                <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                                            </Flex>

                                            <Field name="dispensaLaudo">
                                                {({ field, form }) => (
                                                    <Flex mt={5} flexDir="column">
                                                        <FormControl isInvalid={form.errors.dispensaLaudo && form.touched.dispensaLaudo}>
                                                            <FormLabel htmlFor="dispensaLaudo">Dispensa Laudo Médico para Efeitos do QUF/MPRJ?*</FormLabel>
                                                            <Select
                                                                backgroundColor={"white"}
                                                                id="tipo"
                                                                {...field}
                                                                placeholder="Selecione"
                                                                h="42px"
                                                            >
                                                                <option value={"S"}>Sim</option>
                                                                <option value={"N"}>Não</option>
                                                            </Select>
                                                            <FormErrorMessage>{form.errors.dispensaLaudo}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                        </Box>
                                    </Group>

                                    <Flex mt={2} justifyContent="space-between">
                                        <Flex></Flex>
                                        <Flex flexDir={["column", "row"]}>
                                            <Button
                                                mt={4}
                                                mr={2}
                                                colorScheme="teal"
                                                px={14}
                                                isLoading={props.isSubmitting}
                                                type="submit"
                                                translate="no">
                                                Salvar
                                            </Button>
                                        </Flex>
                                    </Flex>

                                </Flex>
                            </Form>

                        </Flex>
                    )}
                </Formik>
            </Flex >
        </Flex >
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    );
}
export default EditarDoenca;